The additional `WebhookSubscriptionReplay`-specific criteria to filter by.
